import { Switch, Route, Redirect } from 'react-router-dom'
import {
  alphabeticalSort,
  CIMSModule,
  CIMSPage,
  pathify,
} from '@cims-online/shared'
import Administration from './components/Administration'
import Concrete from './components/Concrete'
import ConstructionAdminSubmittals from './components/ConstructionAdminSubmittals'
import DesignSubmittals from './components/DesignSubmittals'
import PayItems from './components/PayItems'
import ImportsExports from './components/ImportsExports'
import FieldDesignChanges from './components/FieldDesignChanges'
import RequestsForInformation from './components/RequestsForInformation'
import Issues from './components/issues/Issues'
import IdentifiedFieldIssues from './components/issues/IdentifiedFieldIssues'
import Materials from './components/Materials'
import EngineeringJudgements from './components/EngineeringJudgements'
import { useProjectContext } from 'context/ProjectContext'
import Home from '../Home'
import Workflow from './components/customWorkflows'
import { ProtectedRoute } from '../../../components/ProtectedRoute'

/**
 * @see {@link Login} component for more information
 */
export const ProjectRoutes: React.FC = () => {
  const { projectId, projectName, workflows, workflowsLoading } =
    useProjectContext()
  const deprecated = CIMSPage.withDeprecatedPaths.flatMap((page) =>
    page.deprecatedProjectPaths.map((from) => {
      const to = from.includes(CIMSPage.deepLink)
        ? page.recordPath
        : page.projectPath
      return { from, to, key: `${from}->${to}` }
    })
  )

  return (
    <Switch>
      {deprecated.map(({ from, key, to }) => (
        <Redirect key={key} to={to} path={from} />
      ))}
      <ProtectedRoute
        path={[pathify(CIMSModule.Home.pathname), CIMSModule.Home.projectPath]}
      >
        <Home
          projectId={projectId}
          projectName={projectName}
          hasWorkflows={workflows.length > 0}
          workflowsLoading={workflowsLoading}
        />
      </ProtectedRoute>
      <Route path={CIMSModule.EJ.projectPath}>
        <EngineeringJudgements />
      </Route>
      <Route path={CIMSModule.ImportsExports.projectPath}>
        <ImportsExports />
      </Route>
      <Route path={CIMSModule.CAS.projectPath}>
        <ConstructionAdminSubmittals />
      </Route>
      <Route path={CIMSModule.DS.projectPath}>
        <DesignSubmittals />
      </Route>
      <Route path={CIMSModule.Concrete.projectPath}>
        <Concrete />
      </Route>
      <Route path={CIMSModule.Admin.projectPath}>
        <Administration />
      </Route>
      <Route path={CIMSModule.PayItems.projectPath}>
        <PayItems />
      </Route>
      <Route path={CIMSModule.FDC.projectPath}>
        <FieldDesignChanges />
      </Route>
      <Route path={CIMSModule.RFI.projectPath}>
        <RequestsForInformation />
      </Route>
      <ProtectedRoute path={pathify(':projectId', 'workflows')}>
        {workflows.sort(alphabeticalSort('label')).map(({ id, label }) => (
          <Route path={pathify(':projectId', 'workflows', id)}>
            <Workflow label={label} />
          </Route>
        ))}
      </ProtectedRoute>
      <Route path={CIMSModule.Issues.projectPath}>
        <Issues />
      </Route>
      <Route path={CIMSModule.IFI.projectPath}>
        <IdentifiedFieldIssues />
      </Route>
      <Route path={CIMSModule.Materials.projectPath}>
        <Materials />
      </Route>
    </Switch>
  )
}
